// List of all possible store operations.
// All constant names should be in UPPER CASE

// Site module
//Getters
export const NB_ELEMENTARY_ZONE = "NB_ELEMENTARY_ZONE";
export const GET_ALL_ELEMENTARY_ZONES = "GET_ALL_ELEMENTARY_ZONES"; /*Evolution majeure de EACM */
export const GET_CLEAN_WORKERS_ELEMENTARY_ZONES = "GET_CLEAN_WORKERS_ELEMENTARY_ZONES";
export const GET_CLEAN_WASTES_ELEMENTARY_ZONES = "GET_CLEAN_WASTES_ELEMENTARY_ZONES";
export const GET_EXTRACTORS_ELEMENTARY_ZONES = "GET_EXTRACTORS_ELEMENTARY_ZONES";

//Mutations
export const UPDATE_SITE_MODEL = "UPDATE_SITE_MODEL";
export const UPDATE_ZONE_WITH_INDEX = "UPDATE_ZONE_WITH_INDEX";
export const UPDATE_AIRLOCK_IN_ZONE = "UPDATE_AIRLOCK_IN_ZONE";
export const UPDATE_BALANCE_SHEET = "UPDATE_BALANCE_SHEET";
export const RESET_SITE_STORE = "RESET_SITE_STORE";

//Settings Module
//Mutations
export const UPDATE_DEPRESSION_TO_MAINTAIN = "UPDATE_DEPRESSION_TO_MAINTAIN";
export const UPDATE_SETTINGS = "UPDATE_SETTINGS";
export const UPDATE_ANSWERS = "UPDATE_ANSWERS";
export const UPDATE_MIN_DEPRESSION = "UPDATE_MIN_DEPRESSION";
export const UPDATE_DUST_LEVEL = "UPDATE_DUST_LEVEL";
export const UPDATE_RENEWAL_RATE = "UPDATE_RENEWAL_RATE";
export const RESET_SETTINGS = "RESET_SETTINGS";
//Actions
export const ACTION_INIT_DEFAULT_SETTINGS = "ACTION_INIT_DEFAULT_SETTINGS";

//Equipments Modules
//Mutations
export const UPDATE_MANDATORY_EXTRACTOR = "UPDATE_MANDATORY_EXTRACTOR";
export const UPDATE_OPTIONAL_EXTRACTOR = "UPDATE_OPTIONAL_EXTRACTOR";
export const UPDATE_MANDATORY_EXTRACTOR_COUNT = "UPDATE_MANDATORY_EXTRACTOR_COUNT";
export const UPDATE_OPTIONAL_EXTRACTOR_COUNT = "UPDATE_OPTIONAL_EXTRACTOR_COUNT";
export const UPDATE_EACM_EQUIPMENT = "UPDATE_EACM_EQUIPMENT";
export const UPDATE_OPTIONAL_EACM_EQUIPMENT = "UPDATE_OPTIONAL_EACM_EQUIPMENT"; /*Evolution Majeure pour EACM*/
export const UPDATE_OPTIONAL_EACM_SITES = "UPDATE_OPTIONAL_EACM_SITES"; /*Evolution Majeure pour EACM*/
export const UPDATE_EAR_EQUIPMENT = "UPDATE_EAR_EQUIPMENT";
export const UPDATE_SECURITY_EXTRACTOR_ENABLED = "UPDATE_SECURITY_EXTRACTOR_ENABLED";
export const UPDATE_IS_EAR_MANDATORY = "UPDATE_IS_EAR_MANDATORY";
export const RESET_EQUIPMENTS = "RESET_EQUIPMENTS";
export const UPDATE_CUSTOM_EQUIPMENT_LABEL = "UPDATE_CUSTOM_EQUIPMENT_LABEL";

//actions
export const UPDATE_MANDATORY_EXTRACTOR_AND_STATUS = "UPDATE_MANDATORY_EXTRACTOR_AND_STATUS";

//Global app data from studio
//actions
export const ACTION_INIT_DATAS = "ACTION_INIT_DATAS";

//mutations
export const UPDATE_ID = "UPDATE_ID";
export const UPDATE_NAME = "UPDATE_NAME";
export const UPDATE_TITLE = "UPDATE_TITLE";
export const UPDATE_SUBTITLE = "UPDATE_SUBTITLE";
export const UPDATE_ILLUSTRATION = "UPDATE_ILLUSTRATION";
export const UPDATE_CATEGORIES = "UPDATE_CATEGORIES";
export const UPDATE_QUESTIONS = "UPDATE_QUESTIONS";
export const UPDATE_CALCULATORS = "UPDATE_CALCULATORS";
export const UPDATE_CHAPO = "UPDATE_CHAPO";
export const UPDATE_LOADED = "UPDATE_LOADED";
export const UPDATE_CONDITIONS_ACCEPTED = "UPDATE_CONDITIONS_ACCEPTED";
export const UPDATE_GLOBAL_SETTINGS = "UPDATE_GLOBAL_SETTINGS";
export const RESET_STORE = "RESET_STORE";
export const UPDATE_DATA_TYPE = "UPDATE_DATA_TYPE";
export const UPDATE_DATA_NAME = "UPDATE_DATA_NAME";
export const UPDATE_DATATYPE_VERSION = "UPDATE_DATATYPE_VERSION";
// Statistics module
//Mutations
export const UPDATE_STATISTICS = "UPDATE_STATISTICS";

//Actions
export const SEND_JSON_STATISTICS = "SEND_JSON_STATISTICS";
export const UPDATE_MENU_COLLAPSED = "UPDATE_MENU_COLLAPSED";
export const UPDATE_CURRENT_STEP = "UPDATE_CURRENT_STEP";
